import React, {Component} from 'react';
import {LayoutSidebar} from "../../Layout";
import {ClientIAAssistantContent} from "./ia_assistant/ClientIAAssistantContent";
import {withRouterParams} from "../../utils/withRouterParams";

export class ClientIAAssistant extends Component {
    render() {
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <ClientIAAssistantContent clientId={this.props.match.params.id}/>
            </div>
        )
    }
}

export default withRouterParams(ClientIAAssistant);
